import ProductListColourComponent from 'components/commercetools-ui/organisms/product/product-list-colour';

function ProductListColourTastic(props: any) {
  return <ProductListColourComponent {...props} />;
}
export default ProductListColourTastic;
